<div class="notif-page">

  <!-- Toolbar -->
  <mat-card class="notif-toolbar-card">
    <mat-card-content class="notif-toolbar">

      <mat-form-field appearance="outline" class="search-field">
        <mat-label>Search notifications</mat-label>
        <input matInput [(ngModel)]="searchTerm" (input)="onSearchChange()"
               placeholder="Message, type, or sender…">
        <mat-icon matPrefix>search</mat-icon>
        <button *ngIf="searchTerm" matSuffix mat-icon-button (click)="searchTerm=''; onSearchChange()">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>

      <div class="notif-filter-chips">
        <button class="notif-chip"
                [class.active]="selectedFilter === 'all'"
                (click)="setFilter('all')">
          <mat-icon class="chip-icon">inbox</mat-icon>
          All
          <span class="chip-count">{{ notifications.length }}</span>
        </button>
        <button class="notif-chip"
                [class.active]="selectedFilter === 'unread'"
                (click)="setFilter('unread')">
          <mat-icon class="chip-icon">mark_email_unread</mat-icon>
          Unread
          <span class="chip-count chip-count-unread">{{ getUnreadCount() }}</span>
        </button>
      </div>

    </mat-card-content>
  </mat-card>

  <!-- Table -->
  <mat-card class="notif-table-card">
    <mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>

    <table mat-table [dataSource]="dataSource" matSort class="notif-table">

      <!-- Read Status dot -->
      <ng-container matColumnDef="readStatus">
        <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
        <td mat-cell *matCellDef="let n" class="read-status-cell">
          <span class="unread-dot" *ngIf="!n.isRead" matTooltip="Unread"></span>
        </td>
      </ng-container>

      <!-- Type -->
      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
        <td mat-cell *matCellDef="let n">
          <span class="type-chip">{{ n.notificationType }}</span>
        </td>
      </ng-container>

      <!-- From -->
      <ng-container matColumnDef="from">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>From</th>
        <td mat-cell *matCellDef="let n">
          <div class="from-cell">
            <ng-container *ngIf="getFromDisplay(n); else noSender">
              <span class="from-name">{{ n.fromUserName }}</span>
              <span *ngIf="n.fromUserTeam" class="from-team">{{ n.fromUserTeam }}</span>
            </ng-container>
            <ng-template #noSender>
              <span class="from-system">System</span>
            </ng-template>
          </div>
        </td>
      </ng-container>

      <!-- Message -->
      <ng-container matColumnDef="message">
        <th mat-header-cell *matHeaderCellDef>Message</th>
        <td mat-cell *matCellDef="let n" class="message-cell"
            [class.unread-message]="!n.isRead"
            [class.actionable-message]="n.actionData"
            [matTooltip]="(n.contents?.length ?? 0) > 80 ? n.contents : ''"
            matTooltipShowDelay="400"
            (click)="n.actionData && performAction(n, $event)">
          {{ n.contents }}
        </td>
      </ng-container>

      <!-- Time -->
      <ng-container matColumnDef="time">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Time</th>
        <td mat-cell *matCellDef="let n" class="time-cell">
          {{ formatTimestamp(n.timeStamp) }}
        </td>
      </ng-container>

      <!-- Actions -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let n" class="actions-cell">
          <button mat-icon-button
                  [disabled]="n.isRead"
                  [matTooltip]="n.isRead ? 'Already read' : 'Mark as read'"
                  (click)="markAsRead(n, $event)">
            <mat-icon>{{ n.isRead ? 'drafts' : 'mark_email_read' }}</mat-icon>
          </button>
          <button mat-icon-button color="primary"
                  matTooltip="Open action"
                  (click)="performAction(n, $event)">
            <mat-icon>open_in_new</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"
          [class.unread-row]="!row.isRead"></tr>

      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell no-data-cell" [attr.colspan]="displayedColumns.length">
          <div class="no-data-message">
            <mat-icon>notifications_none</mat-icon>
            <p>{{ selectedFilter === 'unread' ? 'No unread notifications' : 'No notifications found' }}</p>
          </div>
        </td>
      </tr>

    </table>

    <mat-paginator [pageSizeOptions]="pageSizeOptions" [pageSize]="pageSize" appPersistPageSize="notifications:list" showFirstLastButtons></mat-paginator>
  </mat-card>

</div>
